import { router5Middleware } from 'redux-router5';
import { createRouter } from 'router5';
import browserPlugin from 'router5-plugin-browser';
import loggerPlugin from 'router5-plugin-logger';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { APP_CONFIG } from '@vmos2/core';
import { router5SafeBrowser } from '@vmos2/utils';

import { routes } from './routes';

const preorderDeliveryOnly = settings => {
  try {
    const selectors = filter(JSON.parse(get(settings, 'storeSelection.selectors')), ({ enabled }) => enabled);
    return selectors.length === 1 && selectors[0].type === 'delivery';
  } catch (e) {
    return false;
  }
};

const redirectToDeliveryOnlyPage = (router, dependencies) => (toState, fromState, done) => {
  const { bootstrap } = dependencies;
  const deliveryOnly = preorderDeliveryOnly(bootstrap.settings);

  if (toState.name === 'preorder.store-selection' && get(toState, 'params.app') !== 'delivery' && deliveryOnly) {
    router.navigate('store-selection', { app: 'delivery' });
  }
  done();
};

const scrollToTopOnRouteChangePlugin = () => {
  return {
    onTransitionSuccess: transitionData => {
      if (!get(transitionData, 'meta.options.skipScrolling')) {
        window.scrollTo(0, 0);
      }
    },
  };
};

export const router = createRouter(routes, {
  defaultRoute: 'preorder.store-selection',
});
router.setDependency('routes', routes);

const middleware = [redirectToDeliveryOnlyPage];

router.usePlugin(loggerPlugin);
router.useMiddleware(...middleware);
router.usePlugin(browserPlugin({ useHash: APP_CONFIG.USE_HASH_ROUTES }, router5SafeBrowser));
router.usePlugin(scrollToTopOnRouteChangePlugin);

export const routerMiddleware = router5Middleware(router);
